module.exports = __webpack_public_path__ + "img/pill_error_image.cbbcfb2d.png";